import { isMobile } from '@/util/util'
import { linkToProgram } from '@/api/land.js'
// 唤醒小程序
export async function wakeWechat(url = '', pcUrl, isMdt = false){
  const _this = this
  const mobile = isMobile()
  let href = mobile ? url : pcUrl
  if (mobile && url) {
    // const nuxtApp = useNuxtApp()
    // 小程序唤醒分包的开头
    const rootList = ['pages', 'homePages', 'buyPages', 'minePages'].map(v => v.toLowerCase())
    const pathTitle = url.split('/')[0]
    if (rootList.includes(pathTitle.toLowerCase())) {
      const index = url.indexOf('?')
      const i = index < 0 ? url.length : index
      const params = new URLSearchParams(url.substr(i, url.length))
      const paramsData = Object.fromEntries(params)
      paramsData.path = url.substr(0, i)
      // paramsData.channelCode = getCookie('channelCode')
      // paramsData.channelNo = getCookie('channelNo')
      const { data } = await (linkToProgram(paramsData))
      href = data
      // 小程序唤醒埋点
      // _this.$statistics('OpenOSTAppletClick')
    }
  }
  if (href) {
    // 判断路由是否存在，存在则跳转页面
      window.location.href = href
  } else {
    Toast({
      message: '跳转url为空',
      position: 'bottom'
    })
  }
}



// WEBPACK FOOTER //
// ./src/util/common.js